import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./deliverect_order_type.js";
//#region src/deliverect_order_type_helper.ts
var deliverect_order_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(orderType) {
	switch (orderType) {
		case "1": return "Pick Up";
		case "2": return "Delivery";
		case "3": return "Eat In";
		case "4": return "Curbside";
	}
}
//#endregion
export { deliverect_order_type_helper_exports, name };

//# sourceMappingURL=deliverect_order_type_helper.js.map